// DS3.1, DS3.7
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import InputErrorMessage from '../../lego/InputErrorMessage';
import InputField from '../../lego/InputField';
import InputHint from '../../lego/InputHint';
import InputLabelSubText from '../../lego/InputLabelSubText';
import InputLabelText from '../../lego/InputLabelText';
import InputSuccessMessage from '../../lego/InputSuccessMessage';
import LimitedTextInputField from '../../lego/LimitedTextInputField';
import FormElement from '../../layouts/FormElement';
/**
 * A single line input field with a label and some details.
 */ const TextInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { id, label, isLabelHidden, subLabel, isRequired, details, validationResult, noBottomSpacing, slimBottomSpacing, maxLengthHidden, wrapperClassName } = _param, rest = _object_without_properties(_param, [
        "id",
        "label",
        "isLabelHidden",
        "subLabel",
        "isRequired",
        "details",
        "validationResult",
        "noBottomSpacing",
        "slimBottomSpacing",
        "maxLengthHidden",
        "wrapperClassName"
    ]);
    let wrappedDetails = null;
    const errorMessageId = `${id}-error`;
    const hintId = `${id}-hint`;
    switch(validationResult){
        case 'success':
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputSuccessMessage, null, details);
            break;
        case 'error':
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputErrorMessage, {
                id: errorMessageId
            }, details);
            break;
        default:
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputHint, {
                id: hintId
            }, details);
    }
    const commonInputProps = {
        id,
        isRequired,
        validationResult,
        'aria-errormessage': validationResult === 'error' ? errorMessageId : undefined,
        'aria-describedby': validationResult === undefined && details ? hintId : undefined,
        ref
    };
    return /*#__PURE__*/ React.createElement(FormElement, {
        inputId: id,
        label: /*#__PURE__*/ React.createElement(InputLabelText, {
            isRequired: isRequired
        }, label),
        isLabelHidden: isLabelHidden,
        subLabel: subLabel && /*#__PURE__*/ React.createElement(InputLabelSubText, null, subLabel),
        details: wrappedDetails,
        noBottomSpacing: noBottomSpacing,
        slimBottomSpacing: slimBottomSpacing,
        className: wrapperClassName
    }, rest.maxLength === undefined || maxLengthHidden ? /*#__PURE__*/ React.createElement(InputField, _object_spread({}, commonInputProps, rest)) : /*#__PURE__*/ React.createElement(LimitedTextInputField, _object_spread({
        maxLength: rest.maxLength
    }, commonInputProps, rest)));
});
TextInput.displayName = 'TextInput';
export default TextInput;

//# sourceMappingURL=TextInput.js.map